<template>
  <div class="relative">
    <!-- v-for="(item, index) in 6" :key="index" -->
    <div class="">
      <img
        src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/care%20support%20service%20-%20looking%20for%20a%20caregiver%20saathi.jpg"
        class="w-full custborderradius"
        alt="swiper-img"
      />
    </div>

    <!-- <div
        class="swiper-pagination cust-posi dot-shift"
        slot="pagination"
      ></div> -->
  </div>
</template>
<script>
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.min.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOptions: {
        slidesPerView: 1,
        spaceBetween: 0,
        autoplay: {
          delay: 6000,
          disableOnInteraction: false,
        },
        pagination: {
          el: ".swiper-pagination",
        },
      },
    };
  },

  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
